import * as yup from "yup"
import { ObjectShape } from "yup/lib/object"
import stringRequiredMax from "./stringRequiredMax"
import emailRequired from "./emailRequired"
import messages from "./messages"
import functionRequired from "./functionRequired"

export const Validator = <T extends ObjectShape = ObjectShape>(fields: T) =>
    yup.object().shape(fields)

export {
    stringRequiredMax,
    emailRequired,
    messages,
    functionRequired
}
